import React from "react";
import Box from "../Box";
import { useTheme } from "../styles";
const FormInputLayout = _ref => {
  let {
    gridLayout = null,
    children
  } = _ref;
  const theme = useTheme();
  const inlineInputStyles = {
    display: "grid",
    gridAutoFlow: "column",
    gridAutoColumns: gridLayout || "1fr",
    gap: theme.spacing(1.5),
    mt: 2,
    "& > div": {
      padding: 0
    },
    "@media (max-width: 768px)": {
      gridAutoFlow: "row",
      gridAutoColumns: "1fr"
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    sx: inlineInputStyles
  }, children);
};
export default FormInputLayout;